/**
 * Filter facet permanent links toggle selection in-place. Persisting a listing
 * restore snapshot on those clicks would SYNC_FROM_URL the pre-click filters and
 * wipe multi-select. Skip snapshot for anchors marked as filter permalinks.
 */
export const shouldSkipListingRestoreForAnchor = (
  dataset: Pick<DOMStringMap, 'filterPermalink'> | { filterPermalink?: string },
): boolean => dataset.filterPermalink === 'true';

/**
 * Catalog root crumbs (/fanfics|/originals) reset listing state in-grid.
 * Persisting a pre-click snapshot would re-apply fandom/character filters after
 * soft/hard catalog reset while the URL already shows the empty catalog.
 */
export const shouldSkipListingRestoreForCatalogDestination = (
  anchorPathname: string,
  catalogBasePaths: readonly string[] = ['/fanfics', '/originals'],
): boolean =>
  catalogBasePaths.some(
    (basePath) => anchorPathname === basePath || anchorPathname === `${basePath}/`,
  );
